import { cn } from "@heroui/react";
import { mdiHelpCircleOutline } from "@mdi/js";
import Icon from "@mdi/react";

export function FormField({
  label,
  error,
  children,
  required,
  tooltip,
}: {
  label: string;
  error?: string;
  children: React.ReactNode;
  required?: boolean;
  tooltip?: string;
}) {
  return (
    <div className={cn("scd-drawer-field", error && "scd-drawer-field--error")}>
      <label className="scd-drawer-field__label">
        {label}
        {required && <span className="scd-drawer-field__req">*</span>}
        {tooltip && (
          <span className="scd-drawer-field__tooltip-wrap">
            <Icon
              path={mdiHelpCircleOutline}
              size={0.55}
              className="scd-drawer-field__tooltip-icon"
            />
            <span className="scd-drawer-field__tooltip">{tooltip}</span>
          </span>
        )}
      </label>
      {children}
      {error && <span className="scd-drawer-field__error">{error}</span>}
    </div>
  );
}
